var $ = require('jquery');

$(function () {
    $(".ws-alert__close").on("click", function (event) {
        event.preventDefault();

        $(this).fadeOut(100, function () {
            $(this).parent().remove();
        });
    });

    $(".sc .alert .close").off("click").on("click", function (event) {
        event.preventDefault();

        $(this).parents(".sc .alert").fadeOut(100, function () {
            $(this).remove();
        });
    });

    $(".sc .alert .ws-workflow-command").on("click", function (event) {
        var command = $(this).data("command");

        Sitecore.PageModes.PageEditor.postRequest(
            'item:workflow(language=' + command.Language +
            ',suppresscomment=0,commandid=' + command.CommandId +
            ',ui=0,id=' + command.ItemId +
            ',workflowid=' + command.WorkflowId +
            ',version=' + command.Version + ')', null, false);
    });
});
